import Link from 'next/link';
import { FC } from 'react';
import { formatDistance } from 'date-fns';
export const FeedEntryByline: FC<{
  showTournament?: boolean;
  tournamentId?: number | null;
  tournamentName?: string | null;
  entryDate: Date;
  baseDate: Date;
}> = ({
  showTournament,
  tournamentId,
  tournamentName,
  entryDate,
  baseDate
}) => <p className="text-gray-500 text-xs @lg:text-sm mb-2 @md:mb-4 flex-1" data-sentry-component="FeedEntryByline" data-sentry-source-file="feed-entry-shared.tsx">
    {showTournament && tournamentId && tournamentName && <>
        <Link className="text-bogey-blue" href={`/tournaments/${tournamentId}`}>
          {tournamentName}
        </Link>{' '}
        •{' '}
      </>}
    {formatRelative(entryDate, baseDate)}
  </p>;
function formatRelative(date: Date, baseDate: Date) {
  if (date.getTime() === baseDate.getTime()) {
    return 'Just now';
  }
  return `${formatDistance(baseDate, date)} ago`;
}